exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".table-c7f56 .ant-table-cell{padding:10px !important}.table-c7f56 .ant-table-cell{font-size:14px;color:#262626}.table-c7f56 .ant-table-cell>a{color:#262626}.table-c7f56 th.ant-table-cell{font-size:12px;white-space:nowrap}", ""]);

// Exports
exports.locals = {
	"table": "table-c7f56"
};